<template>
  <div class="RwvContentEdit inner-section">
    <b-form-row>
      <b-col
        v-if="isDraggable"
        md="1" sm="2"
        class="draggable-child">
        <b-button
          size="sm"
          block>
          <i class="material-icons">format_line_spacing</i>
        </b-button>
      </b-col>
      <b-col>
        <b-form-group
          :id="'input-group-content-type-' + index"
          :label-for="'input-content-type-' + index"
          v-b-tooltip.hover
          title="Inhaltstyp">

          <b-form-select
            :id="'input-content-type-' + index"
            v-model="type"
            :value="type"
            required>

            <option slot="first" value="">
              Bitte auswählen...
            </option>

            <option
              v-for="(possibleType, index) in contentTypes"
              :key="index"
              :value="possibleType">
              {{possibleType}}
              </option>
            </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="2" v-if="isWithToggle">
        <b-button
          size="sm"
          block
          variant="outline-danger"
          v-on:click="deleteContent(index)">
          <i class="material-icons">delete</i>
        </b-button>
      </b-col>
    </b-form-row>
    <RwvContentMarkdownEdit
      v-if="content.type == 'Markdown'"
      :markdown="content.data"
      :index="index"
      @changed="dataChanged">
    </RwvContentMarkdownEdit>

    <RwvContentImageEdit
      v-else-if="content.type == 'Image'"
      :image="content.data"
      :index="index"
      :postSlug="$attrs.postSlug"
      @changed="dataChanged">
    </RwvContentImageEdit>

    <RwvContentMarkdownToggleEdit
      v-else-if="content.type == 'MarkdownToggle'"
      :data="content.data"
      :index="index"
      @changed="dataChanged">
    </RwvContentMarkdownToggleEdit>

    <RwvContentHtmlEdit
      v-else-if="content.type == 'HTML'"
      :html="content.data"
      :index="index"
      @changed="dataChanged"/>

    <RwvContentToggleEdit
      v-else-if="content.type == 'Toggle' && isWithToggle"
      :content="content.data"
      :index="index"
      @changed="dataChanged"/>

    <RwvContentEmbedEdit
      v-else-if="content.type == 'Embed'"
      :data="content.data"
      :index="index"
      @changed="dataChanged"/>

    <RwvContentSliderEdit
      v-else-if="content.type == 'Slider'"
      :data="content.data"
      :index="index"
      @changed="dataChanged"/>

    <RwvContentPdfEdit
      v-else-if="content.type == 'Pdf'"
      :data="content.data"
      :index="index"
      :postSlug="postSlug"
      @changed="dataChanged"/>

    <div v-else class="error">
      <p>Nicht unterstützter Inhaltstyp.</p>
    </div>
  </div>
</template>

<script>
import RwvContentMarkdownEdit from "@/components/Contents/Markdown/ContentMarkdownEdit";
import RwvContentMarkdownToggleEdit from "@/components/Contents/MarkdownToggle/ContentMarkdownToggleEdit";
import RwvContentImageEdit from "@/components/Contents/Image/ContentImageEdit";
import RwvContentHtmlEdit from "@/components/Contents/Html/ContentHtmlEdit";
import RwvContentToggleEdit from "@/components/Contents/Toggle/ContentToggleEdit";
import RwvContentEmbedEdit from "@/components/Contents/Embed/ContentEmbedEdit";
import RwvContentSliderEdit from "@/components/Contents/Slider/ContentSliderEdit";
import RwvContentPdfEdit from "@/components/Contents/Pdf/ContentPdfEdit";

export default {
  name: "RwvContentEdit",
  props: {
    content: {
      type: Object,
      required: true
    },
    delete: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      required: true
    },
    isDraggable: {
      type: Boolean,
      default: false
    },
    isWithToggle: {
      type: Boolean,
      default: true
    },
    postSlug: {
      type: String
    }
  },
  components: {
    RwvContentMarkdownEdit,
    RwvContentImageEdit,
    RwvContentMarkdownToggleEdit,
    RwvContentHtmlEdit,
    RwvContentToggleEdit,
    RwvContentEmbedEdit,
    RwvContentSliderEdit,
    RwvContentPdfEdit
  },
  data() {
    return {
      contentTypes: [
        "Markdown",
        "MarkdownToggle",
        "Image",
        "HTML",
        "Toggle",
        "Embed",
        "Slider",
        "Pdf"
      ],
      type: this.content.type
    }
  },
  watch: {
    index(index) {
      console.log("changed index " + index)
    },
    type(type) {
      console.log("type changed " + type)
      if (type == "Markdown") {
        var data = ""
        if (this.content.type == "HTML") {
          data = this.content.data
        }
        this.content.data = data
      } else if (type == "MarkdownToggle") {
        this.content.data = {
          markdown: "",
          variant: "",
          title: ""
        }
      } else if (type == "Image") {
        this.content.data = {
          data: "",
          title: "",
          description: "",
          showTitle: false,
          showDescription: false
        }
      } else if (type == "Toggle") {
        this.content.data = {
          variant: "",
          title: "",
          content: {
            type: "",
            data: ""
          }
        }
      } else if (type == "Embed") {
        this.content.data = {
          ratio: "16by9",
          src: ""
        }
      } else if (type == "Slider") {
        this.content.data = {
          slides: [
            {
              image: "",
              caption: "",
              text: ""
            }
          ],
          interval: 0
        }
      } else if (type == "HTML") {
        var data = ""
        if (this.content.type == "Markdown") {
          data = this.content.data
        }
        this.content.data = data
      } else if (type == "Pdf") {
        var data = {
          pdfTitle: "",
          pdfLink: ""
        }
        this.content.data = data
      }
      this.content.type = type
    },
    content(content) {
      this.$emit("changed", this.index, content)
    }
  },
  methods: {
    dataChanged(data) {
      this.content.data = data
      this.$emit("changed", this.index, this.content)
    },
    deleteContent() {
      this.$emit("delete", this.index)
    }
  }
};
</script>

<style lang="scss" scoped>
.RwvContentEdit {
  background-color: white;
  border-radius: 5px;
  padding: 5px;
  margin: -5px;
}
</style>
